import { gql } from 'graphql-request'
import { UseQueryResult, useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'
import { timersInMilliseconds } from '@/config/polling'
import { SellerLocation } from '@/resources/types/seller'

export const SELLER_LOCATION = gql`
  query sellerLocation {
    seller {
      id
      address {
        location {
          type
          coordinates
        }
      }
      shop {
        coverageArea {
          type
          coordinates
        }
      }
    }
  }
`

export const SELLER_LOCATION_KEY = 'useSellerLocation'

interface SellerLocationData {
  seller: SellerLocation
}

export const useSellerLocation = (): UseQueryResult<SellerLocationData> =>
  useQuery<SellerLocationData>({
    queryKey: [SELLER_LOCATION_KEY],
    queryFn: () => client.request(SELLER_LOCATION),
    staleTime: timersInMilliseconds.fiveMinutes,
  })
